import React from 'react';
import { Routes, Route } from 'app/src/utils/routing';

import McadminChangePassword from './Mcadmin/ChangePassword';
import McadminMailForwards from './Mcadmin/MailForwards';
import McadminProjects from './Mcadmin/Projects';
import McadminUsers from './Mcadmin/Users';

const PTIRoutes = () => {
  return (
    <Routes>
      <Route path="/pti">
        <Route path="mcadmin">
          <Route path="change-password" element={<McadminChangePassword />} />
          <Route path="forwards" element={<McadminMailForwards />} />
          <Route path="projects" element={<McadminProjects />} />
          <Route path="users" element={<McadminUsers />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default PTIRoutes;
